<template>
    <div class="modal fade in" data-backdrop="static" data-keyboard="false" id="ModalUpload">
        <div class="modal-dialog modal-el">
            <div class="modal-content">
                <div class="modal-header">
                    <p class="modal-title"><i class="fa fa-upload"></i> Upload em <b v-if="folder">{{folder.title}}</b>
                    </p>
                    <button type="button" class="close" @click="confirmClose()" aria-hidden="true">×</button>
                </div>
                <div class="modal-body">
                    <form-wizard :startIndex="0" color="#0074D9" style="margin-top:-50px" stepSize="xs" ref="wizard"
                        :title="''" :subtitle="''" shape="tab">
                        <tab-content title="Selecione os arquivos" :before-change="validateFiles"
                            icon="fa fa-file-pdf-o">
                            <tab-file ref="tab1" :request="request"></tab-file>
                        </tab-content>
                        <tab-content title="Adicione Signatários" icon="fa fa-pencil">
                            <tab-signatario ref="tab2" :rendered="display" :request="request"></tab-signatario>
                        </tab-content>
                        <tab-content title="Personalizar" icon="fa fa-cogs">
                            <tab-configurar ref="tab3" :request="request"></tab-configurar>
                        </tab-content>
                        <tab-content :isLastStep="true" title="Concluir" icon="fa fa-check">
                            <tab-confirm ref="tab4" :request="request"></tab-confirm>
                        </tab-content>
                        <button type="button" class="btn-wizard btn btn-primary" slot="prev"> VOLTAR </button>
                        <button type="button" class="btn-wizard btn btn-primary" slot="next"> PROXIMO</button>
                        <button type="button" @click="sendFile()" :disabled="loading" class="btn-wizard btn btn-success"
                            slot="finish">
                            <span>
                                <i class="fa fa-check"></i>
                                CONFIRMAR
                                <i v-show="loading" class="fa fa-circle-o-notch fa-spin"></i>
                            </span>
                        </button>
                    </form-wizard>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        FormWizard,
        TabContent
    } from "vue-form-wizard";
    import TabSignatario from './tab-signatario.vue';
    import TabConfirm from './tab-confirm.vue';
    import TabFile from './tab-file.vue';
    import TabConfigurar from './tab-configurar.vue';

    export default {
        components: {
            FormWizard,
            TabContent,
            TabSignatario,
            TabConfirm,
            TabFile,
            TabConfigurar,
        },
        props: {
            folder: Object
        },
        data() {
            return {
                display: false,
                request: {
                    habilitar_ordem: false,
                    obrigar_certificado: false,
                    mensagem: null,
                    expired_at: null,
                    lembrete: null,
                    signatarios: [],
                    arquivos: [],
                },
                loading: false,
                error: null
            }
        },
        beforeDestroy() {
            this.display = false;
        },
        methods: {
            showModal() {
                this.display = true;
                $("#ModalUpload").modal('toggle');
            },
            confirmClose() {
                let close = confirm('Tem certeza que deseja fechar? Todo progresso será perdido!');
                if (!close) {
                    return
                }
                this.closeModal();
            },
            closeModal() {
                this.$refs.wizard.reset();
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
                this.display = false;
                $('#ModalUpload').modal('toggle');
            },
            validateFiles() {
                if (!this.request.arquivos.length) {
                    toastr({
                        title: 'Informe ao menos um arquivo!',
                        icon: 'error'
                    });
                    this.$validator.validateAll(['file']).then((valid) => {})
                    return false
                }
                this.$validator.reset();
                return true;
            },
            sendFile() {
                this.error = null;
                let formData = new FormData();
                this.request.arquivos.map((file, i) => {
                    formData.append('files[' + i + ']', file);
                });
                this.request.signatarios.map((signatario, i) => {
                    formData.append('signatarios[' + i + ']', JSON.stringify(signatario));
                });
                formData.append('habilitar_ordem', this.request.habilitar_ordem ? 1 : 0);
                formData.append('obrigar_certificado', this.request.obrigar_certificado ? 1 : 0);
                formData.append('expired_at', this.request.expired_at);
                formData.append('lembrete', this.request.lembrete);
                formData.append('mensagem', this.request.mensagem);
                const config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                };
                this.loading = true;
                let req = {
                    req: formData,
                    config: config
                };
                this.$store.dispatch('uploadFile', req).then(response => {
                    toastr({
                        title: response.message,
                        icon: response.status
                    });
                    this.closeModal();
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                }).catch(error => {
                    console.log(error);
                    toastr({
                        title: error.response.data.message,
                        icon: error.response.data.status
                    });
                    this.error = error.response.data.message;
                }).finally(f => {
                    this.loading = false;
                });
            },
        }
    }
</script>

<style scoped>
    .loading:after {
        content: ' .';
        animation: dots 1s steps(5, end) infinite;
    }
</style>